import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Row,
  Form,
  Tabs,
  Modal,
  Input,
  notification,
  InputNumber,
  Select,
  DatePicker,
  Divider,
  Button as Antdbutton,
  Switch,
  Card,
} from 'antd';
import { useModalState } from 'hooks/useModalState';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';

import FormInput from 'components/FormInput';
import { useDisplayFrameworkContext } from 'DisplayFramework/hooks/useDisplayFrameworkContext';
import GetLabel from 'DisplayFramework/components/GetLabel';
import ParListSelect from 'components/ParListSelect';
import Value from 'components/Value';
import OfferPricingApplicationsAttribute from './offerPricingApplicationsAttribute';
import SaveButton from 'components/SaveButtonTabsTop';
import {
  addOfferPricingAttribute,
  updateOfferPricingAttribute,
} from 'services/pricing';
import InputRate from 'components/InputRate';
import UtinaCard from 'components/UtinaCard';
import TypeRoleSelect from 'pages/Configuration/Components/TypeRoleSelect';
import ProcedureInput from 'components/ProcedureInput';
import TaskInput from 'components/TaskInput';
import InputCurrency from 'components/InputCurrency';
import { dateToString, toDatePickerDate } from 'utils/utils2';
import TasksListPopover from 'pages/workflow/TasksListPopover';
import { toCurrency } from 'utils/utils';
import moment from 'moment';
import { isNil } from 'lodash';
import ThirdPartyInput from 'components/ThirdPartyInput';
import TextArea from 'antd/lib/input/TextArea';
import UsageTab from 'pages/Configuration/ManagementCompany/BrokerDetail/UsageTab';

const { TabPane } = Tabs;

type OfferPricingAttributeModalProps = {
  attid?: number;
  offerPricing?: any;
  objectid: number;
  objecttype: string;
  isNew?: boolean;
  visible?: boolean;
  offerPricinglabel: any;
  refetch: () => void;
  onCancel?: () => void;
  currcode: string;
  record?: any;
};

const OfferPricingAttributeModal = ({
  offerPricing,
  objectid,
  objecttype,
  isNew,
  attid,
  refetch,
  visible,
  onCancel,
  currcode,
  offerPricinglabel,
  record,
}: OfferPricingAttributeModalProps) => {
  const history = useHistory();
  const [form] = Form.useForm();
  const [activeKey, setActiveKey] = useState('1');
  const { close, open } = useModalState();
  const { getComponentLabel } = useDisplayFrameworkContext();

  useEffect(() => {
    form.setFieldsValue({
      thirdparty: {
        tpname: record?.tpname,
        tpreference: record?.tpreference,
        tpid: record?.tpid,
      },
    });

    if (offerPricing) {
      form.setFieldsValue({
        attamountdefault: offerPricing.attamountdefault,
        attamountmax: offerPricing.attamountmax,
        attamountmethod: offerPricing.attamountmethod,
        attamountmin: offerPricing.attamountmin,
        attcode: offerPricing.attcode,
        attcoefdefault: offerPricing.attcoefdefault,
        attcoefmax: offerPricing.attcoefmax,
        attcoefmin: offerPricing.attcoefmin,
        attdirection: offerPricing.attdirection,
        attexternalreference: offerPricing.attexternalreference,
        attid: offerPricing.attid,
        attmethod: offerPricing.attmethod,
        attnbdays: offerPricing.attnbdays,
        attrate: offerPricing.attrate,
        atttype: offerPricing.atttype,
        flagaddmanual: offerPricing.flagaddmanual,
        flagdelete: offerPricing.flagdelete,
        flagupdate: offerPricing.flagupdate,
        offerid: offerPricing.offerid,
        priid: offerPricing.priid,
        proccode: offerPricing.proccode,
        requestreceiverid: offerPricing.requestreceiverid,
        requestreceiverroleprofile: offerPricing.requestreceiverroleprofile,
        requestreceivertype: offerPricing.requestreceivertype,
        requesttype: offerPricing.requesttype,
        taskid: offerPricing.taskid,
        valuetofollowup: offerPricing.valuetofollowup,
        proccodefollowup: offerPricing.proccodefollowup,
        taskidfollowup: offerPricing.taskidfollowup,
        targetvaluetofollowup: offerPricing.targetvaluetofollowup,
        tpid: offerPricing.tpid,
        tprole: offerPricing.tprole,
        thirdparty: {
          tpid: offerPricing.tpid ?? 0,
          tpreference: offerPricing?.tpreference ?? '',
          tpname: offerPricing?.tpname ?? '',
        },
        attbudget: offerPricing?.attbudget,
        attbudgetbooked: offerPricing?.attbudgetbooked,
        attbudgetused: offerPricing?.attbudgetused,
        attbudgetavailable:
          offerPricing?.attbudget ??
          0 - offerPricing?.attbudgetbooked ??
          0 - offerPricing?.attbudgetused ??
          0,
        nbmonthsmax: offerPricing.nbmonthsmax,
        flagaddauto: offerPricing.flagaddauto,
        startdate: toDatePickerDate(offerPricing.startdate),
        enddate: toDatePickerDate(offerPricing.enddate),
        status: offerPricing.status,
        statuslabel: offerPricing.statuslabel,
        attcomment: offerPricing.attcomment,
        attlabel: offerPricing.attlabel,
      });
    } else {
      let tpid = localStorage?.getItem('tpid');
      let tprole = localStorage?.getItem('tprole');

      form.setFieldsValue({
        startdate: moment(new Date(), 'YYYY-MM-DD'),
        tprole: tprole,
        thirdparty: {
          tpid: tpid,
          tpreference: 'Me',
          tpname: tprole,
        },
      });
    }
  }, [
    offerPricing,
    form,
    record?.tpname,
    record?.tpreference,
    record?.tpid,
    record,
  ]);
  const INITIAL_VALUES = {
    attamountdefault: 0,
    attamountmax: 0,
    attamountmethod: '',
    attamountmin: 0,
    attcode: '',
    attcoefdefault: 0,
    attcoefmax: 0,
    attcoefmin: 0,
    attdirection: '',
    attexternalreference: '',
    attid: 0,
    attmethod: '',
    attnbdays: 0,
    attrate: 0,
    atttype: '',
    flagaddmanual: true,
    flagdelete: true,
    flagupdate: true,
    offerid: 0,
    priid: 0,
    proccode: '',
    requestreceiverid: 0,
    requestreceiverroleprofile: '',
    requestreceivertype: '',
    requesttype: '',
    taskid: 0,
    tpid: record?.tpidbroker ?? '',
    tprole: 'OEM',
    nbmonthsmax: 0,
    flagaddauto: true,
  };
  return (
    <Modal
      visible={visible}
      title={offerPricinglabel}
      onCancel={onCancel}
      footer={null}
      width={1400}
    >
      <div className="card-container">
        <Tabs
          onChange={(activeKey) => setActiveKey(activeKey)}
          tabBarExtraContent={
            <>
              {offerPricing?.attid && (
                <TasksListPopover
                  entityId={offerPricing.attid}
                  entityName="PRATTRIB"
                  entityReference={offerPricing.attcode}
                  status={offerPricing?.status ?? ''}
                  statusdate={offerPricing?.statusdate ?? ''}
                  onClose={refetch}
                >
                  <Antdbutton>
                    <GetLabel label="actions" />
                  </Antdbutton>
                </TasksListPopover>
              )}
              <SaveButton
                size="middle"
                type="primary"
                comcode="save"
                disabled={!(activeKey === '1')}
                onClick={(ev) => {
                  ev.preventDefault();
                  const values = form.getFieldsValue();
                  const req = {
                    ...INITIAL_VALUES,
                    ...values,
                    tpid: form.getFieldValue('thirdparty')?.tpid,
                    tprole: form.getFieldValue('tprole'),
                    offerid: objecttype === 'OFFER' ? objectid : 0, 
                    priid: objecttype === 'PRICING' ? objectid : 0, 
                    startdate: values.startdate
                      ? moment(values.startdate).format('YYYY-MM-DD')
                      : moment().format('YYYY-MM-DD'),
                    enddate: dateToString(values.enddate),
                    //tpid: record?.tpidbroker,
                  };
                  isNew
                    ? addOfferPricingAttribute({ req }).then((response) => {
                        if (response.code === '200') {
                          notification.success({
                            message: response.message,
                          });
                          form.resetFields();
                          refetch();
                          onCancel && onCancel();
                        }
                      })
                    : updateOfferPricingAttribute({ req }).then((response) => {
                        if (response.code === '200') {
                          notification.success({
                            message: response.message,
                          });
                          refetch();
                          close();
                        }
                      });
                }}
              />
            </>
          }
          type="card"
        >
          <TabPane tab={<GetLabel label="attributeDetail" />} key="1">
            <Card>
              <Form
                form={form}
                layout="vertical"
                initialValues={INITIAL_VALUES}
              >
                <Row gutter={16}>
                  <UtinaCard comcode="attribute" level={4} lg={23}>
                    <Row gutter={16}>
                      <FormInput col xs={24} lg={12} xl={2} name="attid">
                        <Value />
                      </FormInput>
                      <FormInput col xs={24} lg={12} xl={22} name="attlabel">
                        <Input />
                      </FormInput>
                      <FormInput
                        col
                        xs={24}
                        lg={12}
                        xl={6}
                        name="attdirection"
                        rules={[{ required: true }]}
                      >
                        <Select
                          options={[
                            {
                              value: 'IN',
                              label: 'IN',
                            },
                            {
                              value: 'OUT',
                              label: 'OUT',
                            },
                          ]}
                        />
                      </FormInput>
                      <FormInput
                        col
                        xs={24}
                        lg={12}
                        xl={6}
                        name="atttype"
                        rules={[{ required: true }]}
                      >
                        <ParListSelect parcode="PRATTTYPE" />
                      </FormInput>
                      <FormInput
                        col
                        xs={24}
                        lg={12}
                        xl={6}
                        name="attcode"
                        rules={[{ required: true }]}
                      >
                        <ParListSelect
                          parcode="PRATTRIB"
                          onChange={() => {
                            form.setFieldsValue({
                              attmethod: '',
                            });
                          }}
                        />
                      </FormInput>

                      <Form.Item shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          return (
                            <FormInput
                              col
                              xs={24}
                              lg={12}
                              xl={6}
                              name="attmethod"
                              rules={[{ required: true }]}
                            >
                              <ParListSelect
                                parcode="PRATTMETH"
                                parvalueparent={getFieldValue('attcode')}
                              />
                            </FormInput>
                          );
                        }}
                      </Form.Item>
                      <Form.Item shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          return (
                            getFieldValue('attmethod') === 'CREDF' && ( 
                              <FormInput
                                col
                                xs={24}
                                lg={12}
                                xl={6}
                                name="attnbdays"
                              >
                                <InputNumber min={0} />
                              </FormInput>
                            )
                          );
                        }}
                      </Form.Item>

                      <Form.Item shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          return (
                            getFieldValue('attmethod') === 'CREDF' && (  
                              <FormInput
                                col
                                xs={24}
                                lg={12}
                                xl={6}
                                name="attrate"
                              >
                                <InputRate min={0} />
                              </FormInput>
                            )
                          );
                        }}
                      </Form.Item>

                      <FormInput
                        col
                        xs={24}
                        lg={12}
                        xl={6}
                        name="attamountmethod"
                      >
                        <ParListSelect parcode="PRATTAMNT" />
                      </FormInput>
                      <Form.Item shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          return (
                            getFieldValue('attamountmethod') === 'PERC' && ( 
                              <>
                                <FormInput
                                  col
                                  xs={24}
                                  lg={12}
                                  xl={6}
                                  name="attcoefmin"
                                >
                                  <InputRate min={0} />
                                </FormInput>
                                <FormInput
                                  col
                                  xs={24}
                                  lg={12}
                                  xl={6}
                                  name="attcoefdefault"
                                >
                                  <InputRate min={0} />
                                </FormInput>
                                <FormInput
                                  col
                                  xs={24}
                                  lg={12}
                                  xl={6}
                                  name="attcoefmax"
                                >
                                  <InputRate min={0} />
                                </FormInput>
                              </>
                            )
                          );
                        }}
                      </Form.Item>
                      <Form.Item shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          return (
                            getFieldValue('attamountmethod') === 'PERCCAP' && ( 
                              <>
                                <FormInput
                                  col
                                  xs={24}
                                  lg={12}
                                  xl={6}
                                  name="attcoefdefault"
                                >
                                  <InputRate min={0} />
                                </FormInput>
                                <FormInput
                                  col
                                  xs={24}
                                  lg={12}
                                  xl={6}
                                  name="attcoefmax"
                                >
                                  <InputRate min={0} />
                                </FormInput>
                                <FormInput
                                  col
                                  xs={24}
                                  lg={12}
                                  xl={6}
                                  name="attamountmax"
                                >
                                  <InputCurrency min={0} currcode={currcode} />
                                </FormInput>
                              </>
                            )
                          );
                        }}
                      </Form.Item>

                      <Form.Item shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          return (
                            getFieldValue('attamountmethod') === 'INT' && ( 
                              <>
                                <FormInput
                                  col
                                  xs={24}
                                  lg={12}
                                  xl={6}
                                  name="attrate"
                                >
                                  <InputRate min={0} />
                                </FormInput>
                                <FormInput
                                  col
                                  xs={24}
                                  lg={12}
                                  xl={6}
                                  name="nbmonthsmax"
                                >
                                  <InputNumber min={0} />
                                </FormInput>
                              </>
                            )
                          );
                        }}
                      </Form.Item>
                      <Form.Item shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          return (
                            getFieldValue('attamountmethod') === 'INTCAP' && ( 
                              <>
                                <FormInput
                                  col
                                  xs={24}
                                  lg={12}
                                  xl={6}
                                  name="attrate"
                                >
                                  <InputRate min={0} />
                                </FormInput>
                                <FormInput
                                  col
                                  xs={24}
                                  lg={12}
                                  xl={6}
                                  name="nbmonthsmax"
                                >
                                  <InputNumber min={0} />
                                </FormInput>
                                <FormInput
                                  col
                                  xs={24}
                                  lg={12}
                                  xl={6}
                                  name="attamountmax"
                                >
                                  <InputCurrency min={0} currcode={currcode} />
                                </FormInput>
                              </>
                            )
                          );
                        }}
                      </Form.Item>

                      <Form.Item shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          return (
                            getFieldValue('attamountmethod') === 'AMOUNT' && ( 
                              <>
                                <FormInput
                                  col
                                  xs={24}
                                  lg={12}
                                  xl={6}
                                  name="attamountmin"
                                >
                                  <InputCurrency min={0} currcode={currcode} />
                                </FormInput>
                                <FormInput
                                  col
                                  xs={24}
                                  lg={12}
                                  xl={6}
                                  name="attamountmax"
                                >
                                  <InputCurrency min={0} currcode={currcode} />
                                </FormInput>
                                <FormInput
                                  col
                                  xs={24}
                                  lg={12}
                                  xl={6}
                                  name="attamountdefault"
                                >
                                  <InputCurrency min={0} currcode={currcode} />
                                </FormInput>
                              </>
                            )
                          );
                        }}
                      </Form.Item>

                      <Divider />

                      <FormInput
                        col
                        xs={24}
                        lg={12}
                        xl={6}
                        name="startdate"
                        shouldUpdate
                      >
                        <DatePicker />
                      </FormInput>
                      <FormInput
                        col
                        xs={24}
                        lg={12}
                        xl={6}
                        name="enddate"
                        shouldUpdate
                      >
                        <DatePicker />
                      </FormInput>

                      <FormInput
                        col
                        xs={24}
                        lg={12}
                        xl={6}
                        name="statuslabel"
                        shouldUpdate
                      >
                        <Value />
                      </FormInput>
                      <FormInput
                        col
                        xs={24}
                        lg={12}
                        xl={6}
                        name="attexternalreference"
                      >
                        <Input />
                      </FormInput>
                      <FormInput col xs={24} lg={12} xl={6} name="attbudget">
                        <InputCurrency currcode={localStorage.getItem('currcode') ?? ''} />
                      </FormInput>

                      <FormInput
                        col
                        xs={24}
                        lg={12}
                        xl={6}
                        name="attbudgetbooked"
                      >
                        <Value formatter={toCurrency} />
                      </FormInput>

                      <FormInput
                        col
                        xs={24}
                        lg={12}
                        xl={6}
                        name="attbudgetused"
                      >
                        <Value formatter={toCurrency} />
                      </FormInput>

                      <FormInput
                        col
                        xs={24}
                        lg={12}
                        xl={6}
                        name="attbudgetavailable"
                      >
                        <Value formatter={toCurrency} />
                      </FormInput>
                      <Divider />
                      <Form.Item shouldUpdate noStyle>
                        <FormInput
                          col
                          xs={24}
                          lg={12}
                          xl={6}
                          name="valuetofollowup"
                        >
                          <ParListSelect parcode="PRATTFWUP" />
                        </FormInput>
                      </Form.Item>
                      <Form.Item shouldUpdate noStyle>
                        <FormInput
                          col
                          xs={24}
                          lg={12}
                          xl={6}
                          name="targetvaluetofollowup"
                        >
                          <InputNumber />
                        </FormInput>
                      </Form.Item>
                      <FormInput
                        col
                        xs={24}
                        lg={12}
                        xl={6}
                        name="proccodefollowup"
                      >
                        <ProcedureInput
                          entity="PRATTRIB"
                          onChange={() => {
                            form.setFieldsValue({
                              taskid: '' as any,
                            });
                          }}
                        />
                      </FormInput>

                      <Form.Item shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          return (
                            <FormInput
                              col
                              xs={24}
                              lg={12}
                              xl={6}
                              name="taskidfollowup"
                            >
                              <TaskInput
                                proccode={form.getFieldValue(
                                  'proccodefollowup'
                                )}
                              />
                            </FormInput>
                          );
                        }}
                      </Form.Item>

                      <Form.Item shouldUpdate noStyle>
                        {({ getFieldValue, setFieldsValue }) => {
                          return (
                            <>
                              <FormInput
                                col
                                xs={24}
                                lg={12}
                                xl={6}
                                name="flagupdate"
                                shouldUpdate
                                valuePropName="checked"
                                style={{ width: '80% !important' }}
                              >
                                <Switch
                                  checkedChildren={<CheckOutlined />}
                                  unCheckedChildren={<CloseOutlined />}
                                  checked={getFieldValue('flagupdate')}
                                  onChange={(e) => {
                                    setFieldsValue({
                                      flagupdate: e,
                                    });
                                  }}
                                />
                              </FormInput>

                              <FormInput
                                col
                                xs={24}
                                lg={12}
                                xl={6}
                                name="flagdelete"
                                shouldUpdate
                                style={{ width: '80% !important' }}
                              >
                                <Switch
                                  checkedChildren={<CheckOutlined />}
                                  unCheckedChildren={<CloseOutlined />}
                                  checked={getFieldValue('flagdelete')}
                                  onChange={(e) => {
                                    setFieldsValue({
                                      flagdelete: e,
                                    });
                                  }}
                                />
                              </FormInput>

                              <FormInput
                                col
                                xs={24}
                                lg={12}
                                xl={6}
                                name="flagaddmanual"
                                shouldUpdate
                                style={{ width: '80% !important' }}
                              >
                                <Switch
                                  checkedChildren={<CheckOutlined />}
                                  unCheckedChildren={<CloseOutlined />}
                                  checked={getFieldValue('flagaddmanual')}
                                  onChange={(e) => {
                                    setFieldsValue({
                                      flagaddmanual: e,
                                    });
                                  }}
                                />
                              </FormInput>

                              <FormInput
                                col
                                xs={24}
                                lg={12}
                                xl={6}
                                name="flagstrictcheck"
                                shouldUpdate
                                style={{ width: '100% !important' }}
                              >
                                <Switch
                                  checkedChildren={<CheckOutlined />}
                                  unCheckedChildren={<CloseOutlined />}
                                  checked={getFieldValue('flagstrictcheck')}
                                  onChange={(e) => {
                                    setFieldsValue({
                                      flagstrictcheck: e,
                                    });
                                  }}
                                />
                              </FormInput>
                              <FormInput
                                col
                                xs={24}
                                lg={12}
                                xl={6}
                                name="flagaddauto"
                                shouldUpdate
                                style={{ width: '100% !important' }}
                              >
                                <Switch
                                  checkedChildren={<CheckOutlined />}
                                  unCheckedChildren={<CloseOutlined />}
                                  checked={getFieldValue('flagaddauto')}
                                  onChange={(e) => {
                                    setFieldsValue({
                                      flagaddauto: e,
                                    });
                                  }}
                                />
                              </FormInput>
                            </>
                          );
                        }}
                      </Form.Item>

                      <Form.Item shouldUpdate={() => true} noStyle>
                        {({ getFieldValue, setFieldsValue }) => {
                          return (
                            <>
                              <FormInput
                                col
                                xs={24}
                                lg={12}
                                xl={6}
                                name="tprole"
                                hidden={getFieldValue('atttype') !== 'PART'}
                              >
                                <ParListSelect
                                  parcode="TPSERVROLE"
                                  onChange={(e) => {
                                    setFieldsValue({
                                      thirdparty: null,
                                    });
                                  }}
                                />
                              </FormInput>
                              <FormInput
                                col
                                xs={24}
                                lg={12}
                                xl={12}
                                name="thirdparty"
                                hidden={getFieldValue('atttype') !== 'PART'}
                              >
                                <ThirdPartyInput
                                  role={getFieldValue('tprole')}
                                  isCreate={false}
                                />
                              </FormInput>
                            </>
                          );
                        }}
                      </Form.Item>
                      <FormInput
                        col
                        xs={24}
                        lg={12}
                        xl={6}
                        name="attexternalreference"
                      >
                        <Input />
                      </FormInput>

                      <UtinaCard comcode="Workflow&Check" level={4} lg={23}>
                        <Row gutter={16}>
                          <TypeRoleSelect label="request" lg={6} />
                          <FormInput col xs={24} lg={12} xl={6} name="proccode">
                            <ProcedureInput
                              entity="PROPOSAL"
                              onChange={() => {
                                form.setFieldsValue({
                                  taskid: '' as any,
                                });
                              }}
                            />
                          </FormInput>

                          <Form.Item shouldUpdate noStyle>
                            {({ getFieldValue }) => {
                              return (
                                <FormInput
                                  col
                                  xs={24}
                                  lg={12}
                                  xl={6}
                                  name="taskid"
                                >
                                  <TaskInput
                                    proccode={form.getFieldValue('proccode')}
                                  />
                                </FormInput>
                              );
                            }}
                          </Form.Item>
                        </Row>
                      </UtinaCard>

                      <UtinaCard comcode="comment" level={4} lg={23}>
                        <Row gutter={16}>
                          <FormInput name="attcomment" col xl={24}>
                            <TextArea rows={5}></TextArea>
                          </FormInput>
                        </Row>
                      </UtinaCard>
                    </Row>
                  </UtinaCard>
                </Row>
              </Form>
            </Card>
          </TabPane>
          <TabPane
            tab={<GetLabel label="criteria" />}
            key="2"
            disabled={isNil(offerPricing?.attid)}
          >
            <OfferPricingApplicationsAttribute attid={attid ?? 0} />
          </TabPane>
          <TabPane
            tab={<GetLabel label="Usage" />}
            key="3"
            disabled={offerPricing === undefined} 
          >
            <Card>
              <UsageTab offerPricing={offerPricing} />
            </Card>
          </TabPane>
        </Tabs>
      </div>
    </Modal>
  );
};

export default OfferPricingAttributeModal;
